class LocalizationForm extends HTMLElement {
  connectedCallback() {
    this.classList.remove('no-js-hidden');

    this.button = this.querySelector('.disclosure__button');
    this.panel = this.querySelector('.disclosure__list-wrapper');
    this.input = this.querySelector('input[name="country_code"], input[name="locale_code"]');
    this.form = this.querySelector('form');

    if (this.button) {
      this.button.addEventListener('click', this.togglePanel.bind(this));
    }

    this.querySelectorAll('.disclosure__link').forEach((link) =>
      link.addEventListener('click', this.onItemClick.bind(this))
    );

    this._onDocumentClick = this.onDocumentClick.bind(this);
    document.addEventListener('click', this._onDocumentClick);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this._onDocumentClick);
  }

  togglePanel() {
    const expanded = this.button.getAttribute('aria-expanded') === 'true';
    this.button.setAttribute('aria-expanded', String(!expanded));
    if (expanded) {
      this.panel.setAttribute('hidden', '');
    } else {
      this.panel.removeAttribute('hidden');
    }
  }

  onItemClick(evt) {
    evt.preventDefault();
    if (this.input) this.input.value = evt.currentTarget.dataset.value;
    if (this.form) this.form.submit();
  }

  onDocumentClick(evt) {
    if (!this.contains(evt.target) && this.panel) {
      this.button.setAttribute('aria-expanded', 'false');
      this.panel.setAttribute('hidden', '');
    }
  }
}

customElements.define('localization-form', LocalizationForm);
